import verify from "./verify";
import prompt from "./prompt";

export default{
    ...verify,
    ...prompt
}